import { makeStyles } from '@material-ui/core';

import { tokens } from '@styles';

const AVATAR_COLORS = ['#05d3b6', '#ffc001', '#5456fe'];
const withAvatar = {
  marginRight: 15,
};

export default makeStyles((theme) => ({
  drawer: {
    width: '95%',
    borderTopLeftRadius: tokens.radius.lg,
    borderBottomLeftRadius: tokens.radius.lg,
    [theme.breakpoints.up('sm')]: {
      width: 500,
    },
  },

  root: {
    overflow: 'hidden',
    padding: '1rem',
    [theme.breakpoints.up('sm')]: {
      padding: '1rem 2rem',
    },
  },

  actions: {
    justifyContent: 'space-between',
  },

  userIcon: {
    ...withAvatar,
  },

  divider: {
    margin: '1rem 0',
  },

  indicator1: { ...withAvatar, backgroundColor: AVATAR_COLORS[0] },
  indicator2: { ...withAvatar, backgroundColor: AVATAR_COLORS[1] },
  indicator3: { ...withAvatar, backgroundColor: AVATAR_COLORS[2] },
}));
